import React from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

function Home() {
  const navigate = useNavigate();

  const handleCardClick = (page) => {
    navigate(`/login?redirect=${encodeURIComponent(page)}`);
  };

  return (
    <div className="container mt-2">
      {/* Heading */}
      {/* <h2 className="text-center" style={{ color: "red", fontWeight: "bold" }}>
        TO VOTE ONLINE
      </h2> */}

      {/* Voting Cards */}
      <div className="row">
        {/* Vote Card */}
        <div
          className="col-md-12 text-center"
          onClick={() => handleCardClick("/voting")}
          style={{ cursor: "pointer" }}
        >
          <div style={{ position: "relative", display: "inline-block" }}>
            <img
              src="/images/home1.webp"
              className="section-image"
              alt="Vote"
            />
            <img
              src="/images/speaker.webp"
              alt="Vote"
              className="section-speaker"
            />
          </div>
        </div>

        {/* Track My Casted Vote */}
        <div
          className="col-md-12 text-center"
          onClick={() => handleCardClick("/track-casted")}
          style={{ cursor: "pointer" }}
        >
          <div style={{ position: "relative", display: "inline-block" }}>
            <img
              src="/images/home2.webp"
              className="section-image"
              alt="Vote"
            />
            <img
              src="/images/speaker.webp"
              alt="Vote"
              className="section-speaker"
            />
          </div>
        </div>
      </div>

      {/* Track My Bogus Vote */}
      <div
        className="col-md-12 text-center"
        onClick={() => handleCardClick("/track-bogus")}
        style={{ cursor: "pointer" }}
      >
        <div style={{ position: "relative", display: "inline-block" }}>
          <img src="/images/home3.webp" className="section-image" alt="Vote" />
          <img
            src="/images/speaker.webp"
            alt="Vote"
            className="section-speaker"
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
